/**
 * 话题论坛api
 */

import { getFetch, postFetch } from '@/plugins/http'
const baseHost = `${process.env.VUE_APP_HOST}/hike-boot`

export default {
  /***** 话题论坛  **********/

  // 门户-话题论坛-列表
  getTopicForumList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/34-list/portal_topic`, params, config)
  },
  // 门户-话题论坛-详情
  getTopicForumDetail(params = {}, config) {
    return getFetch(`${baseHost}/common/api/30-detail/portal_topic`, params, config)
  },
  // 门户-话题论坛-话题点赞详情
  getTopicForumLikeInfo(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-getLikeInfo/manage_comment`, params, config)
  },
   // 门户-话题论坛-话题点赞
  addTopicForumLike(params = {}, config) {
    return postFetch(`${baseHost}/common/api/10-saveLike/manage_comment`, params, config)
  },
  // 门户-话题论坛-评论列表
  getCommentList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-comment_page_web/manage_comment`, params, config)
  },
  // 门户-话题论坛-评论权限
  getPressionComments(params = {}, config) {
    return getFetch(`${baseHost}/common/api/30-switch_query/manage_comment`, params, config)
  },
  // 门户-话题论坛-添加评论
  addComment(params = {}, config) {
    return postFetch(`${baseHost}/common/api/10-comment_add/manage_comment`, params, config)
  },
  // 门户-话题论坛-删除评论
  removeComment(params = {}, config) {
    return postFetch(`${baseHost}/common/api/91-comment_del/manage_comment`, params, config)
  },
  // 门户-话题论坛-点赞评论
  addLikeComment(params = {}, config) {
    return postFetch(`${baseHost}/common/api/10-like_add/manage_comment`, params, config)
  },
}
